import { render, staticRenderFns } from "./lawyerTag.vue?vue&type=template&id=2c0cec3d&scoped=true&"
import script from "./lawyerTag.vue?vue&type=script&lang=js&"
export * from "./lawyerTag.vue?vue&type=script&lang=js&"
import style0 from "./lawyerTag.vue?vue&type=style&index=0&id=2c0cec3d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0cec3d",
  null
  
)

export default component.exports